import { render, staticRenderFns } from "./stockscanIn.vue?vue&type=template&id=1a75d526&scoped=true"
import script from "./stockscanIn.vue?vue&type=script&lang=js"
export * from "./stockscanIn.vue?vue&type=script&lang=js"
import style0 from "./stockscanIn.vue?vue&type=style&index=0&id=1a75d526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a75d526",
  null
  
)

export default component.exports